import { render, staticRenderFns } from "./merchantVoucherRedemptions.vue?vue&type=template&id=01d72ebc&"
import script from "./merchantVoucherRedemptions.vue?vue&type=script&lang=js&"
export * from "./merchantVoucherRedemptions.vue?vue&type=script&lang=js&"
import style0 from "./merchantVoucherRedemptions.vue?vue&type=style&index=0&id=01d72ebc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports